import React from 'react';

const RING_RADIUS = 18;
const RING_CIRCUMFERENCE = 2 * Math.PI * RING_RADIUS;

function ringColor(pct) {
  if (pct == null) return null;
  if (pct < 40) return 'var(--sig-red)';
  if (pct < 70) return 'var(--sig-amber)';
  return 'var(--sig-green)';
}

export default function ReadinessRing({ value, size = 44 }) {
  const hasValue = value != null && !Number.isNaN(value);
  const pct = hasValue ? Math.round(value * 100) : null;
  const color = ringColor(pct);
  const dashOffset = hasValue
    ? RING_CIRCUMFERENCE * (1 - (pct / 100))
    : RING_CIRCUMFERENCE;

  return (
    <div className="tv3-ring" style={{ width: size, height: size }}>
      <svg width={size} height={size} viewBox="0 0 44 44">
        <circle cx="22" cy="22" r={RING_RADIUS} fill="none" stroke="#e5e2db" strokeWidth="3.5" />
        {hasValue && (
          <circle
            cx="22"
            cy="22"
            r={RING_RADIUS}
            fill="none"
            stroke={color}
            strokeWidth="3.5"
            strokeDasharray={RING_CIRCUMFERENCE}
            strokeDashoffset={dashOffset}
            strokeLinecap="round"
          />
        )}
      </svg>
      <span className="tv3-ring-value" style={{ color: hasValue ? undefined : 'var(--text-muted)' }}>
        {hasValue ? `${pct}%` : '—'}
      </span>
    </div>
  );
}

export function bandTextColor(value) {
  if (value == null) return 'var(--text-muted)';
  const pct = value * 100;
  if (pct < 40) return 'var(--sig-red-text)';
  if (pct < 70) return 'var(--sig-amber-text)';
  return 'var(--sig-green-text)';
}

export function bandRingColor(value) {
  if (value == null) return 'var(--text-muted)';
  const pct = value * 100;
  if (pct < 40) return 'var(--sig-red)';
  if (pct < 70) return 'var(--sig-amber)';
  return 'var(--sig-green)';
}
